import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import RavenFormikSelectComp from "./RavenFormikFieldComps/RavenFormikSelectComp";
import RavenFormikCheckBoxComp from "./RavenFormikFieldComps/RavenFormikCheckBoxComp";
import RavenFormikMultiSelectComp from "./RavenFormikFieldComps/RavenFormikMultiSelectComp";
import RavenFormikTextAreaComp from "./RavenFormikFieldComps/RavenFormikTextAreaComp";
import RavenFormikDefaultComp from "./RavenFormikFieldComps/RavenFormikDefaultComp";
import RavenFormikRadioButtonComp from "./RavenFormikFieldComps/RavenFormikRadioButtonComp";

import { propTypes } from "react-bootstrap/esm/Image";

class RavenFormikField extends Component {
  constructor(props) {
    super(props);
  }

  handleOnChange = e => {
    this.props.setFieldValue(this.props.name, e.target.value);

    if (this.props.onChange) this.props.onChange(e, this.props.setFieldValue);
  };

  handleMultiSelectOnChange = options => {
    if (this.props.onChange)
      this.props.onChange(options, this.props.setFieldValue);
  };

  getClassName = (type, component) => {
    let className;

    if (type === "select") className = " form-select ";
    else if (type === "checkbox") className = " form-check-input ";
    else className = " form-control ";

    return (
      className +
      (this.props.errors[this.props.name] && this.props.touched[this.props.name]
        ? " is-invalid"
        : "")
    );
  };

  getDescription = item => {
    if (Array.isArray(this.props.nameOnValueList)) {
      let data = "";
      let sep = " - ";
      this.props.nameOnValueList.forEach((field, index, array) => {
        data = data + item[field] + (index + 1 === array.length ? "" : sep);
      });

      return data;
    } else return item[this.props.nameOnValueList];
  };

  render() {
    if (this.props.component === "select") {
      return (
        <RavenFormikSelectComp
          name={this.props.name}
          label={this.props.t(this.props.label)}
          divClassName={this.props.divClassName}
          disabled={this.props.disabled}
          placeholder={this.props.placeholder}
          valueList={this.props.valueList}
          defaultOption={this.props.t("pleaseSelect")}
          getDescription={this.getDescription}
          getClassNameValue={this.getClassName(
            this.props.type,
            this.props.component,
          )}
        />
      );
    } else if (this.props.component === "multiselect") {
      return (
        <RavenFormikMultiSelectComp
          name={this.props.name}
          label={this.props.t(this.props.label)}
          divClassName={this.props.divClassName}
          type={this.props.type}
          placeholder={this.props.placeholder}
          valueList={this.props.valueList}
          defaultOption={this.props.t("pleaseSelect")}
          getDescription={this.getDescription}
          onChange={this.props.onChange}
          errors = {this.props.errors}
          touched ={this.props.touched}
          disabled= {this.props.disabled}
          handleMultiSelectOnChange = {this.handleMultiSelectOnChange}
        />
      );
    } else if (this.props.type === "textarea") {
      return (
        <RavenFormikTextAreaComp
          name={this.props.name}
          label={this.props.t(this.props.label)}
          divClassName={this.props.divClassName}
          disabled={this.props.disabled}
          placeholder={this.props.placeholder}
          getClassNameValue={this.getClassName(
            this.props.type,
            this.props.component,
          )}
          maxLength={this.props.maxLength}
          value={this.props.value}
          rows={this.props.rows}
          onChange ={this.props.onChange}
          handleOnChange ={this.handleOnChange}
        />
      );
    } else if (this.props.type === "checkbox") {
      return (
        <RavenFormikCheckBoxComp
          name={this.props.name}
          label={this.props.t(this.props.label)}
          divClassName={this.props.divClassName}
          disabled={this.props.disabled}
          placeholder={this.props.placeholder}
          type={this.props.type}
          getClassNameValue={this.getClassName(
            this.props.type,
            this.props.component,
          )}
          checked ={this.props.checked}
          onChange ={this.props.onChange}
          handleOnChange ={this.handleOnChange}
          htmlLabel={this.props.htmlLabel}
          htmlLabelClick={this.props.htmlLabelClick}
        />
      );
    }
    else if (this.props.component === "radiobutton") {
      return (
        <RavenFormikRadioButtonComp
          name={this.props.name}
          label={this.props.t(this.props.label)}
          divClassName={this.props.divClassName}
          disabled={this.props.disabled}
          placeholder={this.props.placeholder}
          type={this.props.type}
          getClassNameValue={this.getClassName(
            this.props.type,
            this.props.component,
          )}
          checked ={this.props.checked}
          onChange ={this.props.onChange}
          handleOnChange ={this.handleOnChange}
          htmlLabel={this.props.htmlLabel}
          htmlLabelClick={this.props.htmlLabelClick}
        />
      );
    } else {
      return (
        <RavenFormikDefaultComp
          name={this.props.name}
          label={this.props.t(this.props.label)}
          divClassName={this.props.divClassName}
          disabled={this.props.disabled}
          type={this.props.type}
          placeholder={this.props.placeholder}
          hideLabel={this.props.hideLabel}
          maxLength={this.props.maxLength}
          style={this.props.style}
          getClassNameValue={this.getClassName(
            this.props.type,
            this.props.component,
          )}
          value={this.props.value}
          onChange ={this.props.onChange}
          handleOnChange ={this.handleOnChange}
        />
      );
    }
  }
}

RavenFormikField.propTypes = {
  divClassName: PropTypes.string,
  errors: PropTypes.any.isRequired,
  touched: PropTypes.any.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
  type: PropTypes.string,
  checked: PropTypes.any,
  rows: PropTypes.number,
  component: PropTypes.any,
  valueList: PropTypes.array,
  nameOnValueList: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onChange: PropTypes.func,
  setFieldValue: PropTypes.func,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  hideLabel: PropTypes.bool,
  maxLength: PropTypes.string,
  t: PropTypes.any,
  style: PropTypes.string,
  htmlLabel:PropTypes.bool,
  htmlLabelClick:PropTypes.func
};

export default withTranslation()(RavenFormikField);
